import React, { useState, useContext } from "react";
import { Dropdown, Button, Card, Input, Row, Col, Divider, Select } from "antd";
import { IoIosArrowUp } from "react-icons/io";
import mainContext from "../context/MainContext/mainContext";
import formatIndianNumber from "../../../../../utils/formatIndianNumber";
const { Option } = Select;
const DropdownComponent = ({
  subTotal,
  salesOrderData,
  handleFormChange,
  grandTotal,
}) => {
  let { justView } = useContext(mainContext);
  const [visible, setVisible] = useState(false);
  const handleVisibleChange = (flag) => {
    setVisible(flag);
  };

  // Dropdown content
  const dropdownContent = (
    <Card className="grandTotal-card">
      <Row>
        <Col span={12}>Municipal Tax</Col>
        <Col span={12} style={{ textAlign: "right" }}>
          <Input
            min={0}
            value={salesOrderData?.municipalTax}
            onChange={(e) => handleFormChange("municipalTax", e.target.value)}
            style={{ width: "4rem" }}
            controls={false}
            readOnly={justView}
          />
          &nbsp;%
        </Col>
      </Row>
      <Row>
        <Col span={12}>Others</Col>
        <Col span={12} style={{ textAlign: "right" }}>
          <Input
            min={0}
            value={salesOrderData?.otherTaxes}
            onChange={(e) => handleFormChange("otherTaxes", e.target.value)}
            style={{ width: "4rem" }}
            controls={false}
            readOnly={justView}
          />
          &nbsp;%
        </Col>
      </Row>
      <Row>
        <Col span={12}>+Round</Col>
        <Col span={12} style={{ textAlign: "right" }}>
          <Input
            min={0}
            value={salesOrderData?.round}
            onChange={(e) => handleFormChange("round", e.target.value)}
            style={{ width: "4rem" }}
            controls={false}
            readOnly={justView}
          />
          &nbsp;%
        </Col>
      </Row>
      <Divider />
      <Row>
        <Col span={12}>GST</Col>
        <Col span={12} style={{ textAlign: "right", marginBottom: "0.5rem" }}>
          {formatIndianNumber(
            (subTotal * (salesOrderData?.SGST + salesOrderData?.CGST)) / 100
          )}
        </Col>
      </Row>
      <Row>
        <Col span={8}>+IGST</Col>
        <Col span={8}>
          <Select
            className="custom-select-bdf"
            value={Number(salesOrderData?.IGST)}
            defaultValue={0}
            onChange={(value) => handleFormChange("IGST", value)}
            disabled={justView}
            style={{ width: "4rem" }}
          >
            <Option value={0}>0</Option>
            <Option value={5}>5</Option>
            <Option value={18}>18</Option>
            <Option value={28}>28</Option>
          </Select>
          &nbsp;%
        </Col>
        <Col span={8} style={{ textAlign: "right" }}>
          {formatIndianNumber((subTotal * salesOrderData?.IGST) / 100)}
        </Col>
      </Row>
      <Row>
        <Col span={8}>+SGST</Col>
        <Col span={8}>
          <Select
            className="custom-select-bdf"
            value={Number(salesOrderData?.SGST)}
            defaultValue={0}
            onChange={(value) => handleFormChange("SGST", value)}
            disabled={justView}
            style={{ width: "4rem" }}
          >
            <Option value={0}>0</Option>
            <Option value={2.5}>2.5</Option>
            <Option value={9}>9</Option>
            <Option value={14}>14</Option>
          </Select>
          &nbsp;%
        </Col>
        <Col span={8} style={{ textAlign: "right" }}>
          {formatIndianNumber((subTotal * salesOrderData?.SGST) / 100)}
        </Col>
      </Row>
      <Row>
        <Col span={8}>+CGST</Col>
        <Col span={8}>
          <Select
            className="custom-select-bdf"
            value={Number(salesOrderData?.CGST)}
            defaultValue={0}
            onChange={(value) => handleFormChange("CGST", value)}
            disabled={justView}
            style={{ width: "4rem" }}
          >
            <Option value={0}>0</Option>
            <Option value={2.5}>2.5</Option>
            <Option value={9}>9</Option>
            <Option value={14}>14</Option>
          </Select>
          &nbsp;%
        </Col>
        <Col span={8} style={{ textAlign: "right" }}>
          {formatIndianNumber((subTotal * salesOrderData?.CGST) / 100)}
        </Col>
      </Row>
      <Divider />

      <Row>
        <Col span={12}>
          <div style={{ display: "flex", alignItems: "center" }}>
            <span className="agencyComm-span">(+/-) Agency Comm</span>
            <Input
              min={0}
              value={salesOrderData?.agencyCommission}
              // readOnly={true}
              onChange={(e) =>
                handleFormChange("agencyCommission", e.target.value)
              }
              style={{ marginLeft: "1.3rem" }}
              controls={false}
            />
            &nbsp;%
          </div>
        </Col>

        <Col span={12} style={{ textAlign: "right" }}>
          {formatIndianNumber(
            (subTotal * salesOrderData?.agencyCommission) / 100
          )}
        </Col>
      </Row>

      <Row>
        <Col span={12}>Subtotal</Col>
        <Col span={12} style={{ textAlign: "right", marginBottom: "0.5rem" }}>
          {formatIndianNumber(subTotal)}
        </Col>
      </Row>
      <Divider />
      <Row style={{ marginTop: "10px", fontWeight: "bold" }}>
        <Col span={12}>Grand Total</Col>
        <Col span={12} style={{ textAlign: "right" }}>
          {formatIndianNumber(grandTotal)}
        </Col>
      </Row>
    </Card>
  );

  // return (
  //   <Dropdown
  //     overlay={dropdownContent}
  //     trigger={["click"]}
  //     open={visible}
  //     onVisibleChange={handleVisibleChange}
  //   >
  //     <Button style={{ fontWeight: "bold", width: "30rem" }}>
  //       Grand Total:
  //       <span style={{ marginLeft: "12rem" }}>
  //         {formatIndianNumber(grandTotal)}{" "}
  //         <IoIosArrowUp style={{ marginLeft: "1rem" }} />
  //       </span>
  //     </Button>
  //   </Dropdown>
  // );

  return (
    <Button style={{ fontWeight: "bold", width: "30rem" }}>
      Grand Total:
      <span style={{ marginLeft: "12rem" }}>
        {formatIndianNumber(grandTotal)}{" "}
      </span>
    </Button>
  );
};

export default DropdownComponent;
